<script setup lang="ts">
import { type ButtonSize } from '@collector/shared-ui'
import ChangePossessionButton from '@desktop/views/Relation/Sports/components/RelationView/Main/PitchWithIncidents/ChangePossessionButton.vue'

interface Props {
  changePossessionButtonSize?: ButtonSize
}

defineProps<Props>()
</script>

<template>
  <div class="flex-gap-y-fluid">
    <slot />
    <div class="flex items-stretch gap-2">
      <slot name="beforeChangePossession" />
      <div class="min-w-0 flex-1">
        <ChangePossessionButton :size="changePossessionButtonSize" />
      </div>
      <slot name="afterChangePossession" />
    </div>
  </div>
</template>
